<div class="app-container">
  <loading-spinner [isLoading]="loading()" [classesString]="'top-50'"></loading-spinner>
  @if (queryPayment.data() && queryPaymentTypes.data()) {
    <form [formGroup]="paymentForm" (ngSubmit)="isCreating() ? createPayment.mutate() : updatePayment.mutate()">
      <page-header
        [icon]="'far-credit-card'"
        [title]="isCreating() ? 'payment.new' : 'payment'"
        [appendNoTranslationTitlePart]="queryPayment.data() ? queryPayment.data().name : ''"
      >
        <ng-container class="header-button">
          <btn
            [label]="'save'"
            [title]="'save' | translate"
            [classes]="['btn-first', 'float-right', isCreating() ? '' : 'ms-2']"
            [btnDisabled]="loading()"
            [icon]="'far-check'"
            [btnType]="'submit'"
            [isLoading]="loading()"
            [spinnerClassesString]="'spinner-white'"
            [dataCyAttribute]="'create-payment'"
          ></btn>
          @if (!isCreating()) {
            <btn
              [btnType]="'button'"
              [label]="'delete'"
              [title]="'delete' | translate"
              [classes]="['btn-first-red', 'float-right']"
              [icon]="'far-trash-alt'"
              (onEvent)="deletePayment.mutate()"
              [dataCyAttribute]="'delete-payment'"
            ></btn>
            <modal-loggable-history
              [objectClass]="'Payment'"
              [objectId]="queryPayment.data()?.id"
            ></modal-loggable-history>
          }
        </ng-container>
        <ng-container class="back-button">
          <btn
            [label]="'back'"
            [title]="'back' | translate"
            [isBackButton]="true"
            [classes]="['btn-third', 'float-right', 'me-2']"
            [icon]="'far-arrow-left'"
            (onEvent)="goBack()"
          ></btn>
        </ng-container>
      </page-header>
      <section class="content">
        <div class="card">
          <div class="row">
            <div class="col-sm-6">
              <form-row-input
                [formGroup]="paymentForm"
                formControlName="name"
                [required]="paymentForm.get('name').errors !== null && paymentForm.get('name').errors.required"
                [requiredCssClass]="submitted() && formControls.name.errors"
                [label]="'payment.name'"
                [dataCyAttribute]="'name'"
              ></form-row-input>
              <form-row-select
                [label]="'payment.type'"
                [formGroup]="paymentForm"
                formControlName="type"
                [options]="queryPaymentTypes.data()"
                [dataCyAttribute]="'payment-type-select'"
              ></form-row-select>
              <form-row-select
                [label]="'payment.dispatchUnpaid'"
                [formGroup]="paymentForm"
                formControlName="dispatchUnpaid"
                [options]="dispatchUnpaidOptions"
                [dataCyAttribute]="'payment-dispatchUnpaid'"
              ></form-row-select>
            </div>
          </div>
        </div>
      </section>
    </form>
  }
</div>
